import Slider from "react-slick";

export default function Slider63({ items, slidesToShow = 6, slidesToShowMb = 2, slidesToScroll = 1, style, className }) {
    const settingsSlide = {
        infinite: false,
        arrows: true,
        slidesToShow: +slidesToShow,
        slidesToScroll: +slidesToScroll,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: +slidesToShowMb,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    };

    return <div className={"flashSale slide-wrapper " + className} style={style}>
        <div className="slider">
            <Slider {...settingsSlide}>
                {items}
            </Slider>
        </div>
    </div>;
}